/* eslint-disable no-unused-vars */
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { store } from 'redux/store';
import { checkIsInspectionIsPassedOrNot } from './inspection';

export const transformFormWrapperDataToNewCheck = ({ checkData, checkId }) => {
  let newRecordId = localStorage.getItem('newRecordId') || uuidv4();

  const uniqueId = !_.isEmpty(checkId) ? checkId : newRecordId;

  const { pipeline, structure, cache } = store.getState();

  const { pipelineMobileMap = {}, pipelineMobile = [] } = pipeline;
  const { structureMobile = [], structureMobileMap = {} } = structure;
  const { equipmentsMap = {}, equipments: cacheEquipments = [] } = cache;

  let appliesToType = '';
  let uniqueSiteIdsForPipeline = [];
  let structureSiteId = '';
  let equipmentSiteId = '';
  if (!checkId || !checkData?.appliesToType) {
    appliesToType = checkData?.siteId
      ? 'site'
      : checkData?.equipmentId
      ? 'equipment'
      : checkData?.structureId
      ? 'structure'
      : checkData?.pipelineId
      ? 'pipeline'
      : '';
  } else {
    appliesToType = checkData?.appliesToType;
  }

  if (appliesToType === 'pipeline') {
    const pipeLineData = checkId
      ? {}
      : pipelineMobile[pipelineMobileMap[checkData?.pipelineId]] || {};

    const siteIds = pipeLineData
      ? new Set([
          ...(pipeLineData?.fromSite ? [pipeLineData.fromSite] : []),
          ...(pipeLineData?.toSite ? [pipeLineData.toSite] : []),
          ...(pipeLineData?.sites?.map((x) => x.toLowerCase()) ?? []),
          ...(pipeLineData?.wells?.map((x) => x.toLowerCase()) ?? [])
        ])
      : [];

    // get unique site ids, if work request created from pipeline
    uniqueSiteIdsForPipeline = checkData?.sites || Array.from(siteIds);
  } else if (appliesToType === 'structure') {
    const structureData = checkId
      ? {}
      : structureMobile[structureMobileMap[checkData?.structureId]] || {};
    structureSiteId = checkData?.siteId || structureData?.siteId;
  } else if (appliesToType === 'equipment') {
    const equipmentData =
      checkId && checkData?.appliesToType && checkData?.siteId
        ? {}
        : cacheEquipments[equipmentsMap[checkData?.equipmentId]] || {};
    equipmentSiteId = checkData?.siteId || equipmentData?.siteId;
  }

  return {
    appliesToType,
    newCheck: true,
    status: checkData?.status,
    type: 'Check',
    id: uniqueId,
    inspectionFormId: checkData?.inspectionFormId,
    inspectionTypeId: checkData?.inspectionTypeId,
    siteId: checkData?.siteId || structureSiteId || equipmentSiteId || null,

    equipmentId: checkData?.equipmentId || null,
    pipelineId: checkData?.pipelineId || null,
    structureId: checkData?.structureId || null,
    formData: checkData?.formData || null,

    startLatitude: checkData?.startLatitude,
    startLongitude: checkData?.startLongitude,
    completionLatitude: checkData?.completionLatitude,
    completionLongitude: checkData?.completionLongitude,

    description: checkData?.description || '',
    identifier: checkData?.identifier || '',
    location: checkData?.location || '',
    sites: uniqueSiteIdsForPipeline,

    checkedDate: checkData?.checkedDate
      ? checkData?.checkedDate
      : moment().format('YYYY-MM-DDTHH:mm:ss')
  };
};

export const prepareCheckForBackend = ({
  data,
  inspectionFormsUserCache,
  formData,
  failureCriteria,
  inspectionResultAnswer,
  passFailList,
  passDeficiencyFail,
  passFailFalse,
  equipmentsMap,
  cacheEquipments
}) => {
  const currentFrom =
    inspectionFormsUserCache?.find((x) => x?.inspectionFormId === data?.inspectionFormId) || {};
  const json = transformJSON({ currentFrom, formData });

  const failureCriteriaMap = failureCriteria?.reduce((acc, curr) => {
    acc[curr.value] = curr.label;
    return acc;
  }, {});

  let inspectionPassed = checkIsInspectionIsPassedOrNot({
    failureCriteriaMap,
    currentFrom,
    inspectionResultAnswer,
    passFailList,
    passDeficiencyFail,
    passFailFalse
  });

  let siteId = null,
    equipmentId = null,
    pipelineId = null,
    structureId = null;

  if (currentFrom?.appliesTo === 'Site' && data?.siteId) siteId = data?.siteId;
  else if (currentFrom?.appliesTo === 'Equipment' && data?.equipmentId)
    equipmentId = data?.equipmentId;
  else if (currentFrom?.appliesTo === 'Structure' && data?.structureId)
    structureId = data?.structureId;
  else if (currentFrom?.appliesTo === 'Pipeline' && data?.pipelineId) pipelineId = data?.pipelineId;

  let equipmentNewId = '';
  if (
    data?.equipmentId &&
    equipmentsMap[data.equipmentId] >= 0 &&
    cacheEquipments[equipmentsMap[data.equipmentId]]?.isNew
  ) {
    equipmentNewId = data.equipmentId;
  } else if (
    data?.equipmentId &&
    (equipmentsMap[data.equipmentId] < 0 || !equipmentsMap[data.equipmentId])
  ) {
    equipmentNewId = data.equipmentId;
  }

  return {
    assetCheckId: data?.id, // unique Id generated from mobile,
    ...(data?._id && { checkScheduleId: data?._id }),
    siteId: data?.siteId,
    sites: data?.sites?.length > 0 ? data?.sites : [],
    structureId,
    // equipmentId,
    ...(equipmentNewId && { onDemandId: equipmentNewId }),
    ...(!equipmentNewId && data?.equipmentId && { equipmentId: data?.equipmentId }),
    pipelineId,
    inspectionTypeId: data?.inspectionTypeId || null,
    json: null,
    formdata: json,
    // checkedBy: '',
    checkedDate: data?.checkedDate || moment().format('YYYY-MM-DDTHH:mm:ss'),
    // previousNextDue: '',
    // previousNextScheduled: '',
    identifier: data?.identifier || '',
    description: data?.description || '',
    location: data?.location || '',
    comment: data?.comment || '',
    inspectionFormId: data?.inspectionFormId || null,
    // ondemandId: '',
    inspectionPassed,
    startLatitude: data?.startLatitude ? `${data?.startLatitude}` : null,
    startLongitude: data?.startLongitude ? `${data?.startLongitude}` : null,
    completionLatitude: data?.completionLatitude ? `${data?.completionLatitude}` : null,
    completionLongitude: data?.completionLongitude ? `${data?.completionLongitude}` : null
  };
};

const getDefaultValueWhenInspectionResultSelected = ({ form }) => {
  let defaultValue = null;
  for (const section of form.formSections) {
    for (const field of section.formFields) {
      if (field.questionTypeText === 'InspectionResult') {
        defaultValue = field.defaultValue;
        break;
      }
    }
    if (defaultValue) {
      break;
    }
  }
  return defaultValue;
};

export const transformJSON = ({ currentFrom, formData }) => {
  const formDataAnswers = [];
  currentFrom?.formSections?.map((section) => {
    section?.formFields?.map((field) => {
      let removeSpecialCharactersForName = removeSpecialCharacters(
        field?.label?.toString()?.toLowerCase()
      );
      removeSpecialCharactersForName = `${removeSpecialCharactersForName}-${field?.formFieldId}`;
      const answer =
        field?.questionTypeText === 'PhotoQuestion'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.notes
          : field?.questionTypeText === 'PassFailNA' ||
            field?.questionTypeText === 'PassFail' ||
            field?.questionTypeText === 'Scale'
          ? field?.questionTypeText === 'Scale'
            ? parseInt(formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.answer) === 0
              ? 0
              : formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.answer
            : formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.answer || null
          : field?.questionTypeText === 'YNComment'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.value
          : field?.questionTypeText === 'Readings' || field?.questionTypeText === 'Readings_PL'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.textBoxValue
          : field?.questionTypeText === 'Photos'
          ? null
          : field?.questionTypeText === 'InspectionResult'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.inspectionResultAnswer
          : field?.questionTypeText === 'Signature'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.signaturePhoto
          : field?.questionTypeText === 'Time'
          ? moment(formData[removeSpecialCharactersForName]?.[field?.formFieldId]).format('hh:mm')
          : field?.questionTypeText === 'CheckResult'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.checkResultAnswer
          : formData[removeSpecialCharactersForName]?.[field?.formFieldId];
      const assessment =
        field?.questionTypeText === 'Scale'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.assessment
          : null;
      const comment =
        field?.questionTypeText === 'YNComment'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.comment
          : null;

      const notes = ['PhotoQuestion', 'PassFailNA', 'PassFail', 'Scale']?.includes(
        field?.questionTypeText
      )
        ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.notes
        : field?.questionTypeText === 'YNComment'
        ? formData[removeSpecialCharactersForName]?.[field?.form]?.comment
        : null;
      const unit =
        field?.questionTypeText === 'Readings' || field?.questionTypeText === 'Readings_PL'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.textBoxUnitValue
          : null;
      const photos =
        field?.questionTypeText === 'Photos' ||
        ['PhotoQuestion', 'PassFailNA', 'PassFail', 'Scale']?.includes(field?.questionTypeText)
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.photos?.map((x) => {
              return {
                photoId: x?.id,
                caption: x?.caption
              };
            })
          : null;
      const documentId =
        field?.questionTypeText === 'Photos'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.documents?.at(0)?.id
          : null;
      const documentObj = documentId
        ? {
            fieldKey: field?.label,
            fieldId: field?.formFieldId,
            documentId
          }
        : null;
      const multipleDropdownAnswer =
        field?.questionTypeText === 'Dropdown_PL_Multiple' &&
        formData[removeSpecialCharactersForName]?.[field?.formFieldId]
          ? Object.values(formData[removeSpecialCharactersForName]?.[field?.formFieldId])?.map(
              (x) => x?.value
            )
          : null;

      documentObj && formDataAnswers.push(documentObj);
      formDataAnswers.push({
        fieldKey: field?.label,
        fieldId: field?.formFieldId,
        ...(answer &&
          !multipleDropdownAnswer && {
            answer: answer?.toString()
          }),
        ...(multipleDropdownAnswer && {
          listOfMultiValueIds: multipleDropdownAnswer
        }),
        ...(field?.questionTypeText === 'Scale' &&
          assessment && {
            assessment
          }),
        ...(field?.questionTypeText === 'Scale' &&
          answer === 0 && {
            answer: answer?.toString()
          }),
        ...(notes && {
          notes
        }),
        ...(unit && {
          unit
        }),
        ...(photos && {
          photos
        }),
        ...(comment && {
          comment
        })
      });
    });
  });
  return formDataAnswers;
};

const removeSpecialCharacters = (str) => {
  const pattern = /[^a-zA-Z0-9 ]/g;
  const result = str.replace(pattern, '');
  return result;
};
